<template>
  <div>
    <center-nav></center-nav>
    <slider-menu :menuData="menuData"></slider-menu>
  </div>
</template>

<script>
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";
import { mapGetters } from "vuex";
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
export default {
  components: {
    sliderMenu, // 侧边栏
    centerNav, // 头部导航
  },
  data() {
    return {
      oldPathName: 'douyinHome',
      isOpenPoiPermission: false
    }
  },
  async created() {
    DouYinModel.getMasterRelation().then(res => {
      this.isOpenPoiPermission = !!res.data.data.isOpenPoiPermission
    })

  },
  computed: {
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser;
    },
    isDyAppOwner: function () {
      return this.$store.getters.isDyAppOwner;
    },
    ...mapGetters(["isOpenDouyin"]),
    menuData() {
      return [
        {
          path: "/pc/douyin/help",
          icon: "icon-dy_refresh_home_n_1",
          title: "合作引导",
          hidden: this.isOpenDouyin,
          iconSize: '16px'
        },
        {
          path: "/pc/douyin/home/index",
          icon: "icon-dy_refresh_home_n_1",
          title: "数据概况",
          hidden: !this.isOpenDouyin,
          iconSize: '16px'
        },
        {
          path: "/pc/douyin/liveOrderList/index",
          icon: "icon-dy_refresh_zbdd_n_2",
          title: "订单列表",
          hidden: !this.isOpenDouyin,
          iconSize: '16px'
        },
        {
          path: "/pc/douyin/financialDetails/index",
          icon: "icon-dy_refresh_money_n_3",
          title: "分佣明细",
          hidden: !this.isOpenDouyin,
          iconSize: '16px'
        },
        {
          path: "/pc/douyin/distribution",
          icon: "icon-dy_refresh_fxzx_n_4",
          title: "分销中心",
          hidden: !this.isOpenDouyin,
          iconSize: '16px',
          children: [
            {
              path: "/pc/douyin/distribution/masterList",
              title: "达人列表",
            },
            {
              path: "/pc/douyin/distribution/settle",
              title: "达人结佣管理",
            },
            {
              path: "/pc/douyin/proxyList/index",
              title: "分销代理列表",
              hidden: !(this.$store.getters.isSaasProxyUser === 1 && this.$store.getters.isDyAppOwner === 1),
            },
            {
              path: "/pc/douyin/userData",
              title: "分销代理结佣管理",
              hidden: !(this.$store.getters.isSaasProxyUser === 1 && this.$store.getters.isDyAppOwner === 1),
            },
          ],
        },
        {
          path: "/pc/douyin/poiDistribution",
          icon: "icon-dy_refresh_fxzx_n_4",
          title: `POI分销中心`,
          hidden: !this.isOpenPoiPermission,
          iconSize: '16px',
          children: [
            {
              path: "/pc/douyin/poiDistribution/philosopherList",
              title: "达人列表",
            },
            {
              path: "/pc/douyin/poiDistribution/goods",
              title: "推广商品列表",
            },
            {
              path: "/pc/douyin/poiDistribution/commission",
              title: "券佣金列表",
            },
            {
              path: "/pc/douyin/poiDistribution/nonCouponCommission",
              title: "非券订单佣金列表",
            },
            {
              path: "/pc/douyin/poiDistribution/cashFlow",
              title: "资金流水",
            }
          ],
        },
      ];
    },
  },
  watch: {
    $route: {
      // 监听路由变化
      immediate: true,
      handler(val) {
        if (!val.params.go) {
          this.oldPathName = this.$route.name
          this.getPermission();
        }
      },
    },
    isOpenDouyin: {
      // 是否有抖音权限
      handler(val) {
        console.log(val,'valvalvalvalvalval')
        !val
          ? this.$router.push({
            name: "douyinHelp",
            params: {
              go: true,
            },
          })
          : this.$router.push({
            name: this.oldPathName,
            params: {
              go: true,
            },
          });
      },
      // immediate: true,
    },
  },
  methods: {
    // 是否有抖音权限权限
    async getPermission() {
      const res = await DouYinModel.getPermission();
      if (res.data.code === 200) {
        // let testData={
        //   data:{
        //     data:1
        //   }
        // }
        const status = res.data.data !== 0;
        this.$store.commit("nav/SET_ISOPEN_DOUYIN", status);
        if(res.data.data === 0) {
          this.$router.push({
            name: "douyinHelp",
            params: {
              go: true,
            },
          })
        }else {
          this.$router.push({
            name: this.oldPathName,
            params: {
              go: true,
            },
          });
        }

      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/douyin/index.vue